import { createFileRoute } from "@tanstack/react-router";

import { UserSettingsPage } from "src/pages/UserSettingsPage";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/profile",
)({
  component: UserSettingsPage,
});
